import { ApplyAction, SettingsTemplateType } from '@/shared/generated'

export const getApplyActions = (templateType: SettingsTemplateType) => {
	switch (templateType) {
		case SettingsTemplateType.PricingCampaignAnchoring:
		case SettingsTemplateType.PricingCampaignLimits:
		case SettingsTemplateType.PricingCampaignMinimalSteps:
		case SettingsTemplateType.PricingCampaignProductAssignment:
		case SettingsTemplateType.PricingCampaignRounding:
		case SettingsTemplateType.PricingCampaignTacticsMd:
		case SettingsTemplateType.PricingCampaignTacticsMl:
		case SettingsTemplateType.PricingCampaignTacticsRb:
		case SettingsTemplateType.PricingCampaignTacticsPromo:
		case SettingsTemplateType.PricingCampaignActivity:
			return [ApplyAction.UpdatePricingCampaignSettings]
		case SettingsTemplateType.PricingCampaign:
			return [ApplyAction.ReplacePricingCampaignSettings]
		case SettingsTemplateType.Scenario:
			return [ApplyAction.AddWhatIfScenario, ApplyAction.ReplaceMainScenario]
		case SettingsTemplateType.ScenarioStrategy:
		case SettingsTemplateType.ScenarioStopList:
		case SettingsTemplateType.ScenarioBusinessConstraints:
			return [ApplyAction.UpdateScenarioSettings]
		default:
			return undefined
	}
}
